export const STORE_URL = 'https://chrome.google.com/webstore/detail/custom-logo-for-google/pjebhlfhlmpkkikjbhecbmmnabjadlfm';

export const EXT_ID = 'kbhcjecpcoheemdhpddiofgoocdcldcb';

export const DEV_RECAPTCHA_KEY = '6LcbUa4UAAAAAM960F5MbvMIS3Qx8nmcWCkDHA5N';
export const PROD_RECAPTCHA_KEY = '6LcBKbMUAAAAAF6MvhBnrJ5bq6kciIw6koCXKu_9';

// export const EXT_ID = 'pjebhlfhlmpkkikjbhecbmmnabjadlfm';
// export const EXT_ID = 'njcgchgenmgjjdgcblpfnmlbbfkgfhkc';
